import React from 'react';
import BlockChart from '../../BlockChart';
import StackedPercentageBarChart from '../../charts/StackedPercentageBarChart'
import { useGetDashboardConsentsQuery } from '../../../api/dashboardApiSlice';
import consentBarChartTransformer from '../../../services/data/charts/consentBarChartTransformer';
import BlockChartLoader from '../../BlockChartLoader';

export default function ConsentBarChart ( { source, title, filter } ) {
  const defaultData = {"categories":["ios","android"],"series":[{"name":"all","data":[0,0]},{"name":"media","data":[0,0]},{"name":"data","data":[0,0]},{"name":"none","data":[0,0]}]}
  const { data = [], isSuccess, isLoading, isError, refetch } = useGetDashboardConsentsQuery({filter})
  const chartData = consentBarChartTransformer(data, source, defaultData)

  return (
    <BlockChartLoader title={title} success={!isLoading && isSuccess} error={!isLoading && isError} retry={refetch}>
      <StackedPercentageBarChart data={chartData}/>
    </BlockChartLoader>
  )
}
